import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from '../../svg-icon/svg-icon.module';
import { HubLogoModule } from '../../hub-logo/hub-logo.module';
import { RouterModule } from '@angular/router';
import { ForgotPasswordEmailSuccessfullySent } from './forgot-password-email-successfully-sent.component';

@NgModule({
    imports: [
        CommonModule,
        SvgIconModule,
        HubLogoModule,
        RouterModule,
    ],
    exports: [ ForgotPasswordEmailSuccessfullySent ],
    declarations: [ ForgotPasswordEmailSuccessfullySent ],
    entryComponents: [ ForgotPasswordEmailSuccessfullySent ],
})
export class ForgotPasswordEmailSuccessfullySentModule {}
